import { createAction, handleActions, Action } from 'redux-actions'
import {
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE
} from '../../sagas/resetPw/resetPwSaga'
import {
  GET_DISTRICTS_FAILURE,
  GET_SCHOOLS_FAILURE
} from '../../sagas/districtSchool/districtSchoolSaga'
import {
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  REGISTER_FAILURE_EMAIL_EXISTS
} from '../../sagas/registration/registrationSaga'
import {
  FETCH_LEGAL_DOCS_SUCCESS,
  FETCH_LEGAL_DOCS_FAILURE
} from '../../sagas/legalDocs/legalDocsSaga'
import { SAVE_PLAN_SUCCESS } from '../../sagas/savePlan/savePlanSaga.js'
import { FETCH_COURSES_FAILURE } from '../../sagas/gradPlanner/gradPlannerSaga'
import { SHORTEN_URL_SUCCESS } from '../../sagas/shortUrl/shortUrlSaga'
import { actions as authSagaActions } from '../../sagas/auth/authSaga'
import {
  TOGGLE_NAVBAR,
  TOGGLE_ENDORSEMENT_DROPDOWN,
  TOGGLE_QUIZ_DROPDOWN,
  TOGGLE_ABOUT_DROPDOWN,
  TOGGLE_REGISTRATION_MODAL,
  CHANGE_REGISTRATION_PAGE,
  RESET_REGISTRATION_PAGE,
  TOGGLE_RESET_PASS_MODAL,
  TOGGLE_NOTIFICATION_MODAL,
  TOGGLE_NOTIFICATION_MODAL_TRUE,
  TOGGLE_NOTIFICATION_MODAL_FALSE,
  CHANGE_NOTIFICATION,
  TOGGLE_TOS_MODAL,
  TOGGLE_SHORT_URL_MODAL,
  actions as myActions,
  actionCreators as myActionCreators
} from './uiActions'
const errorAsString = payload =>
  typeof payload === 'string' ? payload : 'unkown-error'
export const actions = myActions
export const actionCreators = myActionCreators
export type UiState = {
  showNavbar: boolean,
  showEndorsementDropdown: boolean,
  showQuizDropdown: boolean,
  showAboutDropdown: boolean,
  showRegistrationModal: boolean,
  registrationPage: number,
  showResetPassModal: boolean,
  showNotificationModal: boolean,
  notification: {
    header: string,
    text: string,
    secondText: string,
    buttonText: string
  },
  showTosModal: boolean,
  legalDocs: Array<{
    id: string,
    url: string,
    type: string
  }>,
  showUrlModal: boolean,
  shortUrl: string
}
export const initialState: UiState = {
  showNavbar: false,
  showEndorsementDropdown: false,
  showQuizDropdown: false,
  showAboutDropdown: false,
  showRegistrationModal: false,
  registrationPage: 1,
  showResetPassModal: false,
  showNotificationModal: false,
  notification: {},
  showTosModal: false,
  legalDocs: [],
  showUrlModal: false,
  shortUrl: ''
}

// TODO: Come up with a better way to handle dropdowns

export default handleActions(
  {
    [TOGGLE_NAVBAR]: (state, action: Action<>) => ({
      ...state,
      showNavbar: !state.showNavbar
    }),
    [TOGGLE_ENDORSEMENT_DROPDOWN]: (state, action: Action<>) => ({
      ...state,
      showEndorsementDropdown: !state.showEndorsementDropdown
    }),
    [TOGGLE_QUIZ_DROPDOWN]: (state, action: Action<>) => ({
      ...state,
      showQuizDropdown: !state.showQuizDropdown
    }),
    [TOGGLE_ABOUT_DROPDOWN]: (state, action: Action<>) => ({
      ...state,
      showAboutDropdown: !state.showAboutDropdown
    }),
    [TOGGLE_REGISTRATION_MODAL]: (state, action: Action<>) => ({
      ...state,
      showRegistrationModal: !state.showRegistrationModal
    }),
    [CHANGE_REGISTRATION_PAGE]: (state, action: Action<number>) => ({
      ...state,
      registrationPage: action.payload
    }),
    [TOGGLE_RESET_PASS_MODAL]: (state, action: Action<>) => ({
      ...state,
      showResetPassModal: !state.showResetPassModal
    }),
    [TOGGLE_NOTIFICATION_MODAL]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: !state.showNotificationModal
    }),
    [TOGGLE_NOTIFICATION_MODAL_TRUE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true
    }),
    [TOGGLE_NOTIFICATION_MODAL_FALSE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: false
    }),
    [CHANGE_NOTIFICATION]: (state, action: Action<>) => ({
      ...state,
      notification: action.payload
    }),
    [TOGGLE_SHORT_URL_MODAL]: (state, action: Action<>) => ({
      ...state,
      showUrlModal: !state.showUrlModal
    }),
    [SHORTEN_URL_SUCCESS]: (state, action: Action<>) => ({
      ...state,
      shortUrl: action.payload
    }),
    [RESET_PASSWORD_SUCCESS]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showResetPassModal: false,
      notification: {
        icon: 'RaisedHands',
        header: 'success',
        text: 'checkEmailPasswordReset',
        buttonText: 'ok'
      }
    }),
    [REGISTER_SUCCESS]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'RaisedHands',
        header: 'almostDone',
        text: 'checkEmailRegistration',
        secondText: 'canStillUseSite',
        buttonText: 'explore'
      }
    }),
    [REGISTER_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTroubleRegistration',
        secondText: errorAsString(action.payload),
        buttonText: 'ok'
      }
    }),
    [REGISTER_FAILURE_EMAIL_EXISTS]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTroubleRegistrationEmailExists',
        secondText: 'An account with that email address already exists',
        buttonText: 'ok'
      }
    }),
    [GET_DISTRICTS_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTroubleDistricts',
        secondText: errorAsString(action.payload),
        buttonText: 'ok'
      }
    }),
    [GET_SCHOOLS_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTroubleSchools',
        secondText: errorAsString(action.payload),
        buttonText: 'ok'
      }
    }),
    [FETCH_LEGAL_DOCS_SUCCESS]: (state, action: Action<>) => ({
      ...state,
      legalDocs: action.payload
    }),
    [FETCH_LEGAL_DOCS_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      showRegistrationModal: false,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTroubleLegalDocs',
        secondText: errorAsString(action.payload),
        buttonText: 'ok'
      }
    }),
    [FETCH_COURSES_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTrouble',
        secondText: errorAsString(action.payload),
        buttonText: 'ok'
      }
    }),
    [SAVE_PLAN_SUCCESS]: (state, action: Action) => ({
      ...state,
      showNotificationModal: true,
      notification: {
        icon: 'RaisedHands',
        header: 'success',
        text: 'savedPlan',
        buttonText: 'ok'
      }
    }),
    [TOGGLE_TOS_MODAL]: (state, action: Action<>) => ({
      ...state,
      showTosModal: !state.showTosModal
    }),
    [authSagaActions.USER_TOS_DOCS]: (state, action: Action<>) => {
      if (action.payload.length > 0) {
        return {
          ...state,
          showTosModal: true
        }
      } else {
        return {...state}
      }
    },
    [authSagaActions.ACCEPT_DOC_SUCCESS]: (state, action: Action<>) => ({
      ...state,
      showTosModal: false
    }),
    [RESET_PASSWORD_FAILURE]: (state, action: Action<>) => ({
      ...state,
      showNotificationModal: true,
      notification: {
        icon: 'Oops',
        header: 'oops',
        text: 'havingTrouble',
        buttonText: 'ok'
      }
    })
  },
  initialState
)

export const selectLegalDoc = (legalDocs, type) => {
  let matchedLegalDoc = legalDocs.find(legalDoc => {
    return legalDoc.type === type
  })
  if (matchedLegalDoc) {
    return {
      url: matchedLegalDoc.url,
      text: matchedLegalDoc.type
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/uiReducer.js